<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="block_1 flex-row">
        <img class="image_1" referrerpolicy="no-referrer" src="../../assets/img/head_logo.png" />
        <div class="nav-item" @click="goHome()">
          <span class="nav-text">首页</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item active">
          <span class="nav-text">产品中心</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goService()">
          <span class="nav-text">服务中心</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goAbout()">
          <span class="nav-text">关于我们</span>
          <span class="nav-line"></span>
        </div>
        <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/head_phone.png" />
        <div class="text-wrapper_1">
          <span class="text_5">联系我们：</span>
          <span class="text_6">4000506688</span>
        </div>
      </div>
      <div class="block_22 flex-col">
        <!-- 滑动切换容器 -->
        <div class="slider-container">
          <div class="slider-wrapper" :class="{ 'slide-right': !showFirst }">
            <!-- 1111 -->
            <div class="box_19 flex-col">
              <div class="box_57 flex-row">
                <div class="box_58 flex-col justify-between">
                  <div class="text-group_42 flex-col justify-between">
                    <div class="text-wrapper_17">
                      <span class="text_43">优眼智家</span>
                      <span class="text_44">®</span>
                      <span class="text_45">同视视觉训练仪</span>
                    </div>
                    <span class="text_46">科学视觉训练&nbsp;·&nbsp;衔接日常用眼场景</span>
                  </div>

                  <div class="image-text_1 flex-col">
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">五大模块：调节、融像、弱视刺激、脱抑制、眼球运动</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">预设21种训练方案，提供个性化视觉训练方案</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">具备AI智能调节参数，训练数据云端同步</span>
                    </div>
                  </div>
                </div>
                <img class="image_14" referrerpolicy="no-referrer"
                  src="./assets/img/86d0cd65b7a6fcb9472a46305042f825.png" />
                <div class="box_59 flex-col">
                  <div class="text-wrapper_18 flex-col"><span class="text_47">调节</span></div>
                  <div class="text-wrapper_19 flex-col"><span class="text_48">融像</span></div>
                  <div class="text-wrapper_20 flex-col">
                    <span class="paragraph_10">
                      弱视
                      <br />
                      刺激
                    </span>
                  </div>
                  <div class="text-wrapper_21 flex-col"><span class="text_49">脱抑制</span></div>
                  <div class="text-wrapper_22 flex-col">
                    <span class="paragraph_11">
                      眼球
                      <br />
                      运动
                    </span>
                  </div>
                </div>
                <img class="image_15 slider-arrow" referrerpolicy="no-referrer"
                  src="./assets/img/00b4c7c1fbc953b31fa6329f9b215536.png" @click="slideRight" />
              </div>
              <div class="text-wrapper_59 flex-row justify-between">
                <span class="text_50">
                  训练项目：调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、远融像（集合/散开）、调节灵活度、阶梯聚散。
                </span>
                <span class="text_51">【获批第二类医疗器械注册证】</span>
              </div>
            </div>
            <!-- 222 -->
            <div class="box_19_2 flex-col">
              <div class="group_12 flex-row">
                <img class="image_1 slider-arrow" referrerpolicy="no-referrer"
                  src="https://lanhu-oss-proxy.lanhuapp.com/009e7212b0bac033d38bd8d8e79bc35a" @click="slideLeft" />
                <div class="group_13 flex-col">
                  <span class="text_1">优眼智家智能眼力仪</span>
                  <span class="text_2">全天候守护双眼&nbsp;·&nbsp;视觉健康管家</span>
                  <div class="image-text_1 flex-col">
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">内置7种专业模式，满足多人群需求</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">目镜盘自动切换，智能控制频率</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">支持聚散训练，辅助提升双眼协调</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">兼容手机、书本、平板等多种场景</span>
                    </div>
                  </div>
                </div>
                <img class="image_2" referrerpolicy="no-referrer"
                  src="https://lanhu-oss-proxy.lanhuapp.com/3720cfb414e92990dc6ba2f4f0224a96" />
                <div class="group_14 flex-col">
                  <div class="text-wrapper_1 flex-col">
                    <span class="text_3">日常训练</span>
                  </div>
                  <div class="text-wrapper_2 flex-col">
                    <span class="text_4">用眼放松</span>
                  </div>
                  <div class="text-wrapper_3 flex-col">
                    <span class="text_5">阅读能力</span>
                  </div>
                  <div class="text-wrapper_4 flex-col">
                    <span class="text_6">反应训练</span>
                  </div>
                  <div class="text-wrapper_5 flex-col">
                    <span class="text_7">双眼协调</span>
                  </div>
                  <div class="text-wrapper_6 flex-col">
                    <span class="text_8">休闲护目</span>
                  </div>
                  <div class="text-wrapper_7 flex-col">
                    <span class="text_9">眼花恢复</span>
                  </div>
                </div>
              </div>
              <div class="text-wrapper_15 flex-row justify-between">
                <span class="text_10">适用于家庭、办公等多场景下的日常双眼视觉健康管理与视觉训练辅助。</span>
                <span class="text_11">建议年龄3岁+</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 第二部分 -->
        <div class="box_20 flex-col">
          <div class="section_12 flex-row">
            <img
              class="image_16"
              referrerpolicy="no-referrer"
              src="./assets/img/13ff45a0e38d9fc15ce2fca999ccb8aa.png"
            />
            <div class="group_25 flex-col justify-between">
              <div class="text-group_36 flex-col justify-between">
                <div class="text-wrapper_24">
                  <span class="text_52">优眼智家</span>
                  <span class="text_53">®</span>
                  <span class="text_54">检训一体机</span>
                </div>
                <span class="text_55">检训一体&nbsp;·&nbsp;智慧管理&nbsp;·&nbsp;全链赋能</span>
              </div>

              <div class="image-text_1 flex-col">
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">智能融合【视功能检查】与【视觉训练】</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">自动流程、个性方案、智能化数据管理</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">助力机构搭建标准化视光服务流程</span>
                </div>
              </div>
            </div>
            <div class="group_26 flex-col justify-between">
              <div class="text-wrapper_26 flex-col"><span class="text_60">集成化</span></div>
              <div class="text-wrapper_27 flex-col"><span class="text_61">智能化</span></div>
              <div class="text-wrapper_28 flex-col"><span class="text_62">全周期</span></div>
            </div>
          </div>
          <div class="text-wrapper_54 flex-row">
            <span class="text_63">
              可测项目：调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、调节/聚散灵活度、正/负镜片阅读、立体视。
            </span>
          </div>
        </div>
        <!-- 第三部分 -->
        <!-- box_4 滑动切换容器 -->
        <div class="slider-container-2">
          <div class="slider-wrapper-2" :class="{ 'slide-right-2': !showFirstBox4 }">
            <!-- 111 -->
            <div class="box_4 flex-col">
              <div class="block_23 flex-row">
                <div class="group_27 flex-col justify-between">
                  <div class="text-group_37 flex-col justify-between">
                    <span class="text_1">调节视功能检查仪</span>
                    <span class="text_2">视功能检查专用设备</span>
                  </div>

                  <div class="image-text_1 flex-col">
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">AI智能判读辅助，全程自动跟踪记录</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">智能图表生成，数据量化评估</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">灵活预设方案&nbsp;+&nbsp;专业模式可调</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">报告自动生成，云端同步，联网/单机双模式</span>
                    </div>
                  </div>
                </div>
                <img
                  class="image_18"
                  referrerpolicy="no-referrer"
                  src="./assets/img/7742f0223050acd4abdd36b46a9dc584.png"
                />
                <img
                  class="image_4 slider-arrow"
                  referrerpolicy="no-referrer"
                  src="./assets/img/40e68bcc8e5ca938119506ef600d6235.png"
                  @click="slideRight2"
                />
              </div>
              <div class="text-wrapper_55 flex-row justify-between">
                <span class="text_3">
                  可测项目：近Worth4点、聚散灵活度、调节灵活度、正/负相对调节、调节反应、调节幅度、立体视。
                </span>
                <span class="text_4">【获批第二类医疗器械注册证】</span>
              </div>
            </div>
            <!-- 222 -->
            <div class="box_4 flex-col">
              <div class="block_23_2 flex-row">
                <img class="image_3 slider-arrow" referrerpolicy="no-referrer"
                  src="https://lanhu-oss-proxy.lanhuapp.com/83652a8b244b4f7af687988cec0f20db" @click="slideLeft2" />
                <div class="group_27 flex-col justify-between">
                  <div class="text-group_37 flex-col justify-between">
                    <div class="text-wrapper_9">
                      <span class="text_12">调节视功能检查仪</span>
                      <span class="text_13">(视光版)</span>
                    </div>
                    <span class="text_14">智能诊疗&nbsp;·&nbsp;视功能检查利器</span>
                  </div>
                  <div class="image-text_1 flex-col">
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">支持视功能检查过程的自动判读、动态跟踪记录</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">自动生成动态监测图，检查结果直观呈现</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">一站式自动化操作，辅助简化临床检查流程</span>
                    </div>
                  </div>
                </div>
                <img class="image_11" referrerpolicy="no-referrer"
                  src="https://lanhu-oss-proxy.lanhuapp.com/cfd768e33b78f1e8dd2aab38014d81ea" />
              </div>
              <div class="text-wrapper_16 flex-row">
                <span class="text_15">为视光师提供参考，直观分析近视、斜视、弱视人群的视觉状态，简化操作流程，提升工作便捷性。</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 第四部分 -->
        <!-- box_5 滑动切换容器 -->
        <div class="slider-container-3">
          <div class="slider-wrapper-3" :class="{ 'slide-right-3': !showFirstBox5 }">
            <div class="box_5 flex-col">
              <div class="group_28 flex-row">
                <div class="box_55 flex-col justify-between">
                  <div class="text-group_38 flex-col justify-between">
                    <div class="text-wrapper_2">
                      <span class="text_5">优眼智家</span>
                      <span class="text_6">®</span>
                      <span class="text_7">同视视觉训练仪</span>
                    </div>
                    <span class="text_8">多态运营&nbsp;·&nbsp;视功能训练设备</span>
                  </div>
                  <div class="image-text_1 flex-col">
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">模块化集成设计，智能匹配训练难度</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">趣味化交互界面，覆盖多年龄段训练需求</span>
                    </div>
                    <div class="image-text_2 flex-row">
                      <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                      <span class="paragraph_1">训练全程记录、结果量化可视</span>
                    </div>
                  </div>
                </div>
                <img
                  class="image_6"
                  referrerpolicy="no-referrer"
                  src="./assets/img/ea7b3d1d9c457b10a1369dfa0c5ca79b.png"
                />
                <img
                  class="image_7 slider-arrow"
                  referrerpolicy="no-referrer"
                  src="./assets/img/de6eb33c4e2c5676c1fd40f086672af0.png"
                  @click="slideRight3"
                />
              </div>
              <div class="text-wrapper_56 flex-row justify-between">
                <span class="text_9">
                  训练项目：调节、静/动态融像、棱镜、动态追踪、红光闪烁、红光调节、红绿闪烁、红绿视标、红绿扫描、光栅训练。
                </span>
                <span class="text_10">【获批第二类医疗器械注册证】</span>
              </div>
            </div>
            <div class="box_5_2 flex-row">
              <img class="image_8 slider-arrow" referrerpolicy="no-referrer"
                src="https://lanhu-oss-proxy.lanhuapp.com/5ddedc9b69097b434b32b3330bdbd24d" @click="slideLeft3" />
              <div class="group_7 flex-col">
                <span class="text_16">视光版</span>
                <img class="image_9" referrerpolicy="no-referrer"
                  src="https://lanhu-oss-proxy.lanhuapp.com/0f628301d34ee9b6dccb3a90d3349b80" />
              </div>
              <div class="group_8 flex-col">
                <span class="text_17">普通版</span>
                <img class="image_10" referrerpolicy="no-referrer"
                  src="https://lanhu-oss-proxy.lanhuapp.com/4fcd21ab577c2ee6452ab3cccb909759" />
              </div>
            </div>
          </div>
        </div>
        <!-- 第五部分 -->
        <div class="box_7 flex-col">
          <div class="section_13 flex-row justify-between">
            <div class="box_56 flex-col justify-between">
              <div class="text-group_39 flex-col justify-between">
                <div class="text-wrapper_4">
                  <span class="text_11">优眼智强</span>
                  <span class="text_12">®</span>
                  <span class="text_13">屈光视功能检查仪</span>
                </div>
                <span class="text_14">【屈光检查+视功能检查】集成化专业检查</span>
              </div>
              <div class="image-text_1 flex-col">
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">一体集成：集屈光检查与视功能检查于一体</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">方法灵活：支持多种临床检查方法</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">流程标准：采用自动化标准检查流程</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">配置自由：检查项目按需配置及联网/单机双模式</span>
                </div>
              </div>
            </div>
            <img
              class="image_19"
              referrerpolicy="no-referrer"
              src="./assets/img/f6a4f215dc0e4949d191798ba22d2c82.png"
            />
          </div>
          <div class="section_14 flex-row justify-between">
            <div class="text-wrapper_6">
              <div>可测项目：</div>
              <span class="text_15">屈光+视力检查、Worth4点、Von&nbsp;Greafe法、AC/A、正负融像聚散范围、Maddox杆法、聚散灵活度、调节放松、调节反应、调节幅度、调节紧张、调节灵活度、调节幅度（快速版）、立体视。</span>
            </div>
            <span class="text_16">【获批第二类医疗器械注册证】</span>
          </div>
        </div>
        <div class="box_12 flex-col">
          <div class="block_24 flex-row">
            <div class="group_29 flex-col justify-between">
              <div class="text-wrapper_7 flex-col"><span class="text_17">多项集成</span></div>
              <div class="text-wrapper_8 flex-col"><span class="text_18">方案可选</span></div>
              <div class="text-wrapper_9 flex-col"><span class="text_19">自动记录</span></div>
            </div>
            <img
              class="image_9"
              referrerpolicy="no-referrer"
              src="./assets/img/630d425dac6faecc1918ee688f40e07c.png"
            />
            <div class="group_30 flex-col justify-between">
              <div class="text-group_40 flex-col justify-between">
                <div class="text-wrapper_10">
                  <span class="text_20">优眼智明</span>
                  <span class="text_21">®</span>
                  <span class="text_22">同视视觉训练仪</span>
                </div>
                <span class="text_23">视功能训练设备</span>
              </div>
              <div class="image-text_1 flex-col">
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">4大模块：调节/融像/脱抑制/眼球运动</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">语音引导，一键式自助训练</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">预设训练方案，支持自定义项目设置</span>
                </div>
              </div>
            </div>
          </div>
          <div class="text-wrapper_57 flex-row justify-between">
            <span class="text_24">
              训练项目：调节训练、生理性复视、脱抑制、远/近融像、静/动态融像、三联动、眼球运动训练。
            </span>
            <span class="text_25">【获批第二类医疗器械注册证】</span>
          </div>
        </div>
        <div class="box_13 flex-col">
          <div class="group_31 flex-row justify-between">
            <div class="section_15 flex-col justify-between">
              <div class="text-group_41 flex-col justify-between">
                <div class="text-wrapper_12">
                  <span class="text_26">优眼智全</span>
                  <span class="text_27">®</span>
                  <span class="text_28">视功能检查仪</span>
                </div>
                <span class="text_29">视功能检查专用设备</span>
              </div>
              <div class="image-text_1 flex-col">
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">调节/聚散功能动态检查，客观评估</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">图表化直观呈现，便于多维判读</span>
                </div>
                <div class="image-text_2 flex-row">
                  <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/quan.png" />
                  <span class="paragraph_1">云端数据同步，报告多端查看：手机/电脑/纸质</span>
                </div>
              </div>
            </div>
            <img
              class="image_10"
              referrerpolicy="no-referrer"
              src="./assets/img/1e18bde8bcffc35e9cfb870108a6fb6c.png"
            />
          </div>
          <div class="text-wrapper_58 flex-row justify-between">
            <div class="text-wrapper_6">
              <div>可测项目：</div>
              <span class="text_15">屈光+视力检查、Worth4点、Von&nbsp;Greafe法、AC/A、正负融像聚散范围、Maddox杆法、聚散灵活度、调节放松、调节反应、调节幅度、调节紧张、调节灵活度、调节幅度（快速版）、立体视。</span>
            </div>
            <span class="text_30">【获批第二类医疗器械注册证】</span>
          </div>
        </div>
        <div class="box_15 flex-row">
          <div class="box_16 flex-col">
            <img
              class="image_11"
              referrerpolicy="no-referrer"
              src="./assets/img/824d3b0a8a4f028b79abd4b1c3c44ad5.png"
            />
            <div class="text-wrapper_14">
              <span class="text_31">优眼智家</span>
              <span class="text_32">®</span>
              <span class="text_33">气压眼部按摩仪</span>
            </div>
            <span class="text_34">恒温热敷、气压按摩、可视窗、内置音乐。四种模式可选，轻巧随行，办公居家皆可用。</span>
          </div>
          <div class="box_17 flex-col">
            <img
              class="image_12"
              referrerpolicy="no-referrer"
              src="./assets/img/86be804067cadb0cd17d4b2734b6785f.png"
            />
            <div class="text-wrapper_15">
              <span class="text_35">优眼智家</span>
              <span class="text_36">®</span>
              <span class="text_37">视觉功能训练一体机</span>
            </div>
            <span class="text_38">
              融合智能脑视觉训练理念，训练与游戏化体验深度结合，辅助提升调节、集合、眼球追随及立体视觉能力
            </span>
          </div>
          <div class="box_18 flex-col">
            <img
              class="image_13"
              referrerpolicy="no-referrer"
              src="./assets/img/f81789a311ca4a451dda3cf139568fe3.png"
            />
            <div class="text-wrapper_16">
              <span class="text_39">优眼智家</span>
              <span class="text_40">®</span>
              <span class="text_41">智能眼健康训练仪</span>
            </div>
            <span class="text_42">
              智能翻转&nbsp;+&nbsp;益智游戏，全自动视觉训练，改善眼睛调节与聚散功能，居家管理眼健康。
            </span>
          </div>
        </div>
      </div>
      <div class="bottom_box flex-row">
        <img class="image_11" referrerpolicy="no-referrer" src="../../assets/img/bottom_phone.png" />
        <div class="text-wrapper_20 flex-col justify-between">
          <span class="text_40">联系我们：</span>
          <span class="text_41">400&nbsp;050&nbsp;6688</span>
          <div class="network-keycord">津ICP备2021007957号-1</div>
        </div>
        <div class="image-text_11 flex-col justify-between">
          <img class="image_12" referrerpolicy="no-referrer" src="../../assets/img/bottom_ercode1.png" />
          <span class="text-group_5">视频号</span>
        </div>
        <div class="image-text_12 flex-col justify-between">
          <img class="image_13" referrerpolicy="no-referrer" src="../../assets/img/bottom_ercode2.png" />
          <span class="text-group_6">公众号</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {},
      showFirst: true, // true 显示 box_19, false 显示 box_19_2
      showFirstBox4: true, // true 显示第一个 box_4, false 显示第二个 box_4
      showFirstBox5: true // true 显示 box_5, false 显示 box_5_2
    };
  },
  mounted() {
    this.injectStructuredData();
  },
  beforeDestroy() {
    this.removeStructuredData();
  },
  methods: {
    // 注入结构化数据供 AI 爬虫抓取
    injectStructuredData() {
      // 面包屑导航
      const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": "https://test.uyu.com/uyu_home"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "产品中心",
            "item": "https://test.uyu.com/uyu_product"
          }
        ]
      };

      // 产品页面信息
      const pageData = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "name": "优眼智家产品中心",
        "url": "https://test.uyu.com/uyu_product",
        "description": "优眼智家产品中心展示专业视功能检查与训练设备，包括同视视觉训练仪、检训一体机、调节视功能检查仪等医疗器械。",
        "isPartOf": {
          "@type": "WebSite",
          "name": "优眼智家官网",
          "url": "https://test.uyu.com"
        }
      };

      // 产品分类列表
      const categoryData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "优眼智家产品分类",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "医疗器械",
            "description": "获批第二类医疗器械注册证的专业设备"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "视光产品",
            "description": "智能视觉健康管理与训练设备"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "家庭健康管理",
            "description": "家庭场景下的眼健康产品"
          }
        ]
      };

      // 产品详细列表
      const products = [
        {
          "@type": "Product",
          "name": "优眼智家®同视视觉训练仪",
          "description": "科学视觉训练，衔接日常用眼场景。五大模块：调节、融像、弱视刺激、脱抑制、眼球运动。预设21种训练方案，提供个性化视觉训练方案。具备AI智能调节参数，训练数据云端同步。训练项目：调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、远融像、调节灵活度、阶梯聚散。获批第二类医疗器械注册证。",
          "category": "医疗器械",
          "brand": { "@type": "Brand", "name": "优眼智家" }
        },
        {
          "@type": "Product",
          "name": "优眼智家智能眼力仪",
          "description": "全天候守护双眼，视觉健康管家。智能方案一键预设，镜盘全自动切换，日常双眼视觉健康管理与视觉训练辅助。",
          "category": "视光产品",
          "brand": { "@type": "Brand", "name": "优眼智家" }
        },
        {
          "@type": "Product",
          "name": "优眼智家®检训一体机",
          "description": "检训一体，智慧管理，全链赋能。智能融合视功能检查与视觉训练，自动流程、个性方案、智能化数据管理，助力机构搭建标准化视光服务流程。可测项目：调节基础、静/动态融像、动态追踪、红绿扫描/视标、光栅、调节/聚散灵活度、正/负镜片阅读、立体视。获批第二类医疗器械注册证。",
          "category": "医疗器械",
          "brand": { "@type": "Brand", "name": "优眼智家" }
        },
        {
          "@type": "Product",
          "name": "调节视功能检查仪",
          "description": "AI智能数据管理，检查过程自动判读，全程自动跟踪记录。获批第二类医疗器械注册证。",
          "category": "医疗器械",
          "brand": { "@type": "Brand", "name": "优眼智家" }
        },
        {
          "@type": "Product",
          "name": "优眼智强®屈光视功能检查仪",
          "description": "屈光检查+视功能检查集成化专业检查。适用于眼科常规视功能检查和屈光状态检查。获批第二类医疗器械注册证。",
          "category": "医疗器械",
          "brand": { "@type": "Brand", "name": "优眼智强" }
        },
        {
          "@type": "Product",
          "name": "优眼智明®同视视觉训练仪",
          "description": "4大模块，语音引导，一键式自助训练。获批第二类医疗器械注册证。",
          "category": "医疗器械",
          "brand": { "@type": "Brand", "name": "优眼智明" }
        },
        {
          "@type": "Product",
          "name": "优眼智全®视功能检查仪",
          "description": "调节/聚散功能动态检查，图表化直观呈现。获批第二类医疗器械注册证。",
          "category": "医疗器械",
          "brand": { "@type": "Brand", "name": "优眼智全" }
        },
        {
          "@type": "Product",
          "name": "气压眼部按摩仪",
          "description": "恒温热敷、气压按摩、3D可视、内置音乐。缓解日常用眼疲劳、干涩及黑眼圈。",
          "category": "家庭健康管理"
        },
        {
          "@type": "Product",
          "name": "智能眼健康训练仪",
          "description": "全自动视功能训练，智能翻转设计。适用于家庭场景下的自主眼健康管理。",
          "category": "家庭健康管理"
        },
        {
          "@type": "Product",
          "name": "脑视觉训练软件",
          "description": "将专业视觉训练内容转化为互动游戏。支持同时视、融合视、立体视等功能训练。",
          "category": "家庭健康管理"
        }
      ];

      const productListData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "优眼智家产品列表",
        "description": "优眼智家全系列产品展示",
        "numberOfItems": products.length,
        "itemListElement": products.map((p, i) => ({
          "@type": "ListItem",
          "position": i + 1,
          "item": p
        }))
      };

      // 注入到页面
      const dataList = [
        { id: 'breadcrumb', data: breadcrumbData },
        { id: 'page', data: pageData },
        { id: 'category', data: categoryData },
        { id: 'products', data: productListData }
      ];

      dataList.forEach(item => {
        const script = document.createElement('script');
        script.id = `structured-data-product-${item.id}`;
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(item.data);
        document.head.appendChild(script);
      });
    },
    removeStructuredData() {
      const ids = ['breadcrumb', 'page', 'category', 'products'];
      ids.forEach(id => {
        const script = document.getElementById(`structured-data-product-${id}`);
        if (script) document.head.removeChild(script);
      });
    },
    goHome() {
      this.$router.push('/uyu_home')
    },
    goService() {
      this.$router.push('/uyu_service');
    },
    goAbout() {
      this.$router.push('/uyu_about');
    },
    slideRight() {
      this.showFirst = false;
    },
    slideLeft() {
      this.showFirst = true;
    },
    slideRight2() {
      this.showFirstBox4 = false;
    },
    slideLeft2() {
      this.showFirstBox4 = true;
    },
    slideRight3() {
      this.showFirstBox5 = false;
    },
    slideLeft3() {
      this.showFirstBox5 = true;
    }
  }
};
</script>
<style scoped lang="less" src="./assets/index.response.less" />